// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__NEERI","content":"Contact_content__O8kNK","address":"Contact_address__Xbylv","item":"Contact_item__czfzi"};